import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import PageMeta from './components/PageMeta';
import CookieConsent from './components/CookieConsent';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CollectionsPage from './pages/CollectionsPage';
import WeddingDressesPage from './pages/WeddingDressesPage';
import ProductsPage from './pages/ProductsPage';
import AbiyePage from './pages/AbiyePage';
import KinalikPage from './pages/KinalikPage';
import AccessoriesPage from './pages/AccessoriesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AppointmentPage from './pages/AppointmentPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CartPage from './pages/CartPage';
import ProfilePage from './pages/ProfilePage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailedPage from './pages/PaymentFailedPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import TeslimatIadePage from './pages/TeslimatIadePage';
import GizlilikPage from './pages/GizlilikPage';
import MesafeliSatisPage from './pages/MesafeliSatisPage';
import SearchPage from './pages/SearchPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  /* Ust bosluk BURADA verilmez. Her sayfa kendi konteynerinde header
     yuksekligi kadar padding-top tanimliyor; burada da vermek cift bosluk
     olusturuyordu. */
`;

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <PageMeta />
        <AppContainer>
          <Header />
          <MainContent>
            <Routes>
              {/* Ana Sayfa */}
              <Route path="/" element={<HomePage />} />
              
              {/* Koleksiyonlar */}
              <Route path="/koleksiyonlar" element={<CollectionsPage />} />
              
              {/* Ürünlerimiz Ana Sayfa */}
              <Route path="/ürünlerimiz" element={<ProductsPage />} />
              
              {/* Ürünlerimiz - Gelinlikler */}
              <Route path="/gelinlikler" element={<WeddingDressesPage />} />
              
              {/* Ürünlerimiz - Abiyeler */}
              <Route path="/abiyeler" element={<AbiyePage />} />
              
              {/* Ürünlerimiz - Kınalık */}
              <Route path="/kinaliklar" element={<KinalikPage />} />
              
              {/* Ürünlerimiz - Aksesuar */}
              <Route path="/aksesuar" element={<AccessoriesPage />} />
              
              {/* Ürün Detay Sayfaları */}
              <Route path="/gelinlikler/:slug" element={<ProductDetailPage />} />
              <Route path="/abiyeler/:slug" element={<ProductDetailPage />} />
              <Route path="/kinaliklar/:slug" element={<ProductDetailPage />} />
              <Route path="/aksesuar/:slug" element={<ProductDetailPage />} />
              
              {/* Hakkımızda */}
              <Route path="/hakkimizda" element={<AboutPage />} />
              
              {/* İletişim */}
              <Route path="/iletisim" element={<ContactPage />} />
              
              {/* Admin Panel */}
              <Route path="/admin" element={<AdminPage />} />
              
              {/* Randevu */}
              <Route path="/randevu" element={<AppointmentPage />} />
              
              {/* Auth */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/profil" element={<ProfilePage />} />
              
              {/* Sepet */}
              <Route path="/sepet" element={<CartPage />} />
              
              {/* Ödeme */}
              <Route path="/odeme" element={<CheckoutPage />} />
              <Route path="/odeme-basarili" element={<PaymentSuccessPage />} />
              <Route path="/odeme-basarisiz" element={<PaymentFailedPage />} />
              
              {/* Sipariş Takip */}
              <Route path="/siparis-takip" element={<OrderTrackingPage />} />
              
              {/* Yardım Sayfaları */}
              <Route path="/teslimat-iade" element={<TeslimatIadePage />} />
              <Route path="/gizlilik" element={<GizlilikPage />} />
              <Route path="/mesafeli-satis" element={<MesafeliSatisPage />} />

              {/* Arama */}
              <Route path="/arama" element={<SearchPage />} />

              {/* 404 - hicbir route eslesmezse */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </MainContent>
            <Footer />
            <CookieConsent />
          </AppContainer>
        </Router>
      </CartProvider>
  );
}

export default App;